import img from "../US_img/Mur tendu imprimé design avec motifs de feuilles artistiques dans un salon contemporain – solution décorative Unik System.webp"; 
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function USArtFlow() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });

    
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>ARTFLOW</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Design artistique fluide</h1>

          <p data-aos="fade-up">
            Des créations décoratives modernes aux formes organiques
            qui apportent mouvement, élégance et identité unique à vos espaces.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a href="/contact" className="btn-outline">
              Nous contacter
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US ArtFlow design artistique" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que US ARTFLOW ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US ARTFLOW est une solution de design artistique basée sur des formes
            fluides et contemporaines, permettant de transformer les espaces en
            véritables œuvres architecturales.
          </p>

          <p data-aos="fade-up">
            Adaptée aux projets résidentiels et professionnels, cette solution
            combine créativité, innovation et intégration parfaite dans
            l’environnement architectural.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="🎨"
            title="Design unique"
            text="Créations artistiques originales et personnalisées."
          />
          <Feature
            icon="🌊"
            title="Formes fluides"
            text="Lignes organiques pour un effet dynamique et moderne."
          />
          <Feature
            icon="🏗️"
            title="Intégration architecturale"
            text="Adaptation parfaite à tous types d’espaces."
          />
          <Feature
            icon="✨"
            title="Effet visuel premium"
            text="Valorisation esthétique haut de gamme."
          />
          <Feature
            icon="⚡"
            title="Solutions durables"
            text="Matériaux modernes et résistants."
          />
          <Feature
            icon="🛠️"
            title="Installation maîtrisée"
            text="Mise en œuvre rapide et professionnelle."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Design organique et contemporain</li>
          <li>Matériaux innovants et durables</li>
          <li>Finitions haut de gamme</li>
          <li>Personnalisation complète</li>
          <li>Compatible intérieur et extérieur</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Villas",
            "Hôtels",
            "Restaurants",
            "Commerces",
            "Bureaux",
            "Espaces premium",
            "Showrooms",
            "Espaces publics",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Donnez une identité artistique à vos espaces</h2>
        <p>US ARTFLOW transforme vos idées en créations uniques.</p><br/>
        <a href="/contact" className="btn-primarya">Contactez-nous</a>
      </section>

    </div>
  );
}